import React, {useState, useEffect} from 'react';
import {Button, RefreshIcon, Searchbar, Select, Toolbar} from 'react-unity';
import styled from 'styled-components';
import VirtualMachineRequest from '../../models/entities/VirtualMachineRequest';
import Filter from '../common/tables/Filter';
import CheckboxFilter, {CheckboxOption} from '../common/tables/CheckboxFilter';

const MyP = styled.p`
	margin-right: 8px;
	margin-bottom: auto !important;
	margin-top: auto !important;
`;

export type VMFilters = {
	searchGeneral: string;
	OS: CheckboxOption[];
	environment: CheckboxOption[];
	patchingMode: CheckboxOption[];
	location: CheckboxOption[];
	orderBy: string;
};

interface VirtualMachineHistoryFiltersProps {
	setFilteredRequests: any;
	retreiveVirtualMachineRequests: any;
	virtualMachineRequests: VirtualMachineRequest[];
}

const VirtualMachineHistoryFilters = ({
	setFilteredRequests,
	retreiveVirtualMachineRequests,
	virtualMachineRequests
}: VirtualMachineHistoryFiltersProps) => {

	const defaultFilters = {
		searchGeneral: '',
		OS: [
			{label: 'Windows', value: 'Windows', checked: true},
			{label: 'Linux', value: 'Linux', checked: true},
		],
		environment: [
			{label: 'Development', value: 'Development', checked: true},
			{label: 'Acceptance', value: 'Acceptance', checked: true},
			{label: 'Production', value: 'Production', checked: true},
		],
		patchingMode: [
			{value: 'AutomaticByOS', label: 'Windows automatic update', checked: true},
			{value: 'AutomaticByPlatform', label: 'Azure orchestration patching', checked: true},
			{value: 'userProvidedSchedule', label: 'Update management by tag', checked: true},
		],
		location: [
			{label: 'China North 3', value: 'chinanorth3', checked: true},
		],
		orderBy: 'newest',
	} as VMFilters;

	const filterVMs = () => {
		let filtered = [];

		const filterCallback = (vm: VirtualMachineRequest) => {
			return (
				filter.filterCheckBox('OS', vm.os) &&
				filter.filterCheckBox('environment', vm.environment) &&
				filter.filterCheckBox('patchingMode', vm.patchMode) &&
				filter.filterCheckBox('patchingMode', vm.location) &&
				(filter.filterSearchText('searchGeneral', vm.requesterEmail) ||
					filter.filterSearchText('searchGeneral', vm.resourceGroupName) ||
					filter.filterSearchText('searchGeneral', vm.osDiskType))
			);
		};

		filtered = virtualMachineRequests.filter(filterCallback);

		filtered = filtered.sort((a, b) => {
			if (filter.filters.orderBy === 'newest') {
				return a.id < b.id ? 1 : -1;
			}
			return a.id > b.id ? 1 : -1;
		});

		setFilteredRequests(filtered);
	};

	useEffect(() => {
		filter.updateFilterFunction(filterVMs);
	}, [virtualMachineRequests]);

	useEffect(() => {
		filter.filter();
	}, []);

	const [filter] = useState<Filter<VMFilters>>(new Filter(filterVMs, defaultFilters));

	const handleRefresh = () => {
		retreiveVirtualMachineRequests(true);
	};

	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	return (
		<>
			{filter && (
				<>
					<Toolbar id="toggle-toolbar">
						<Toolbar.Item className="searchbar-width">
							<Searchbar
								condensed
								buttonProps={{onClick: clearSearchbar}}
								inputProps={{
									value: filter.filters.searchGeneral,
									onChange: (e) => filter.handleSearchTextChange(e, 'searchGeneral'),
									placeholder: 'Search (i.e. Virtual Machine Name, Resource Group, etc.)',
								}}
							/>
						</Toolbar.Item>
						<Toolbar.Item right>
							<Button variant="secondary" size="small" onClick={handleRefresh}>
								<RefreshIcon size="small" />
								<span> Refresh</span>
							</Button>
						</Toolbar.Item>
					</Toolbar>
					<Toolbar>
						<Toolbar.Item>
							<CheckboxFilter
								label="Environment"
								onChange={(event) => filter.handleCheckboxChange(event, 'environment')}
								options={filter.filters.environment}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Location"
								buttonProps={{size: 'small'}}
								onChange={(event) => filter.handleCheckboxChange(event, 'location')}
								options={filter.filters.location}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Operating System"
								buttonProps={{size: 'small'}}
								onChange={(event) => filter.handleCheckboxChange(event, 'OS')}
								options={filter.filters.OS}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Patching Mode"
								buttonProps={{size: 'small'}}
								onChange={(event) => filter.handleCheckboxChange(event, 'patchingMode')}
								options={filter.filters.patchingMode}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<span
								className="clear-filters"
								onClick={() =>
									filter.updateFilters({...defaultFilters})
								}
							>
								Clear filters
							</span>
						</Toolbar.Item>
						<Toolbar.Item right>
							<Button.Group>
								<MyP>Sort by</MyP>
								<Select
									style={{ marginBottom: -12 }}
									value={filter.filters.orderBy}
									onChange={(e) => filter.handleSearchTextChange(e, 'orderBy')}
								>
									<option className='em-c-field-option' value="newest">Newest</option>
									<option className='em-c-field-option' value="oldest">Oldest</option>
								</Select>
							</Button.Group>
						</Toolbar.Item>
					</Toolbar>
				</>
			)}
		</>
	);
};

export default VirtualMachineHistoryFilters;
